import styled from 'styled-components';

export const StyledStep = styled.div`
  .step-content-helper-text {
    color: ${({ theme: { token } }) => token.colorTextHeading};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
  }

  .loader-container, .step-content-file-upload {
    height: 224px;
    width: 472px;
    margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
  }

  .loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .step-content-file-upload {
    display: block;

    .upload-icon {
      font-size: 3rem
    }

    .upload-error-icon {
      color: ${({ theme: { token } }) => token.colorError};
    }

    .upload-drag-icon {
      color: ${({ theme: { token } }) => token.colorPrimary};
    }

    .upload-text {
      color: ${({ theme: { token } }) => token.colorText};
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      line-height: ${({ theme: { token } }) => token.lineHeightLG};
      font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
    }

    .upload-hint {
      margin-top: ${({ theme: { token } }) => token.marginXXS}px;
      color: ${({ theme: { token } }) => token.colorTextDescription};
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      line-height: ${({ theme: { token } }) => token.lineHeight};
      font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
    }
  }

  .step-content-tag-list {
    .step-content-tag-list-title {
      color: ${({ theme: { token } }) => token.colorTextHeading};
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      margin-bottom: 1rem;
    }

    .step-content-tag-list-content {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      gap: ${({ theme: { token } }) => token.marginSM}px;

      .step-content-image-tag {
        margin: 0;
        padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingXS}px;
        color: ${({ theme: { token } }) => token.colorPrimary};
        line-height: ${({ theme: { token } }) => token.lineHeightLG};
        font-size: ${({ theme: { token } }) => token.imageTagFontSizeSM}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
      }
    }
  }
`;
